module.exports = __webpack_public_path__ + "img/Porto Apartment - 11 of 85.fcd3c755.jpeg";